export const GetOrderStatusStyles = (status: string) => {
  let statusBgColor, statusTxtColor;

  switch (status) {
    case "Order Placed":
      statusBgColor = "#00B70C30";
      statusTxtColor = "#00B70C";
      break;
    case "Dispatched":
      statusBgColor = "#a79c0033";
      statusTxtColor = "#766e00";
      break;
    case "Cancelled":
      statusBgColor = "#b500003a";
      statusTxtColor = "#b50000";
      break;
    case "Processing":
      statusBgColor = "#bf5f003a";
      statusTxtColor = "#bf6000";
      break;
    case "rejected":
      statusBgColor = "#f83e003a";
      statusTxtColor = "#f83e00";
      break;
    case "Delivered":
      statusBgColor = "#10860031";
      statusTxtColor = "#108600";
      break;
    default:
      statusBgColor = "#14141435";
      statusTxtColor = "#141414";
  }

  return {
    background: statusBgColor,
    color: statusTxtColor,
  };
};
